<!--
=============================================================================
setera-web
=============================================================================
Copyright (c) 2026 HG Digital/Setera
Todos os direitos reservados.

Este software é confidencial e de propriedade da HG Digital/Setera.
Seu uso está sujeito aos termos do contrato de licença.
-----
Criado em : 20-08-2026 16:57:03
Autor     : Diego Brock
Projeto   : setera-web
Versão    : 1.0.0
=============================================================================
-->
<h2 mat-dialog-title>Seleção de terminais</h2>

<div mat-dialog-content class="gateway-router-dialog">
  <p class="gateway-router-hint">
    A seleção inclui terminais de arquiteturas diferentes. Escolha o grupo e os veículos
    para abrir a tela de comandos correspondente. Ao concluir, você poderá voltar aqui
    para atuar no outro grupo.
  </p>

  <div class="gateway-sections">
    <section class="gateway-section" *ngIf="canOpenModern || modernDataSource.data.length">
      <header class="gateway-section-header">
        <div class="gateway-section-title">
          <h3>Nova arquitetura</h3>
          <span class="gateway-count">{{ modernSelection.selected.length }} de {{ modernDataSource.data.length }} selecionados</span>
        </div>
      </header>
      <p class="gateway-section-note" *ngIf="!canOpenModern">
        Sem permissão para comandos da nova arquitetura neste perfil.
      </p>
      <ng-container *ngIf="canOpenModern">
        <div class="gateway-search">
          <input
            type="text"
            class="form-control"
            placeholder="Filtrar por placa..."
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            (keyup)="handleFilter(modernDataSource, modernSearch.value)"
            #modernSearch>
        </div>
        <div class="gateway-list-scroll">
          <table mat-table [dataSource]="modernDataSource" class="mat-elevation-z0 gateway-table">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? masterToggle(modernDataSource, modernSelection) : null"
                  [checked]="modernSelection.hasValue() && isAllSelected(modernDataSource, modernSelection)"
                  [indeterminate]="modernSelection.hasValue() && !isAllSelected(modernDataSource, modernSelection)"
                  [matTooltip]="'Selecionar todos'">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleRow(row, modernSelection) : null"
                  [checked]="modernSelection.isSelected(row)">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="plate">
              <th mat-header-cell *matHeaderCellDef>Placa</th>
              <td mat-cell *matCellDef="let element">
                <div class="plate-cell">
                  <span class="plate-text">{{ element.placa || '-' }}</span>
                  <span class="plate-meta" *ngIf="element.nome_empresa || element.nome_divisao">
                    {{ element.nome_empresa || element.nome_divisao }}
                  </span>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="gateway-row"
              [class.gateway-row-selected]="modernSelection.isSelected(row)"
              (click)="toggleRow(row, modernSelection)"></tr>
          </table>
          <p class="gateway-empty" *ngIf="modernDataSource.filteredData?.length === 0">
            Nenhum terminal encontrado.
          </p>
        </div>
        <div class="gateway-section-actions">
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="openModern()"
            [disabled]="!modernSelection.selected.length">
            Abrir comandos (nova)
          </button>
        </div>
      </ng-container>
    </section>

    <section class="gateway-section" *ngIf="canOpenLegacy || legacyDataSource.data.length">
      <header class="gateway-section-header">
        <div class="gateway-section-title">
          <h3>Legado</h3>
          <span class="gateway-count">{{ legacySelection.selected.length }} de {{ legacyDataSource.data.length }} selecionados</span>
        </div>
      </header>
      <p class="gateway-section-note" *ngIf="!canOpenLegacy">
        Sem permissão para comandos legados neste perfil.
      </p>
      <ng-container *ngIf="canOpenLegacy">
        <div class="gateway-search">
          <input
            type="text"
            class="form-control"
            placeholder="Filtrar por placa..."
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            (keyup)="handleFilter(legacyDataSource, legacySearch.value)"
            #legacySearch>
        </div>
        <div class="gateway-list-scroll">
          <table mat-table [dataSource]="legacyDataSource" class="mat-elevation-z0 gateway-table">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? masterToggle(legacyDataSource, legacySelection) : null"
                  [checked]="legacySelection.hasValue() && isAllSelected(legacyDataSource, legacySelection)"
                  [indeterminate]="legacySelection.hasValue() && !isAllSelected(legacyDataSource, legacySelection)"
                  [matTooltip]="'Selecionar todos'">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleRow(row, legacySelection) : null"
                  [checked]="legacySelection.isSelected(row)">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="plate">
              <th mat-header-cell *matHeaderCellDef>Placa</th>
              <td mat-cell *matCellDef="let element">
                <div class="plate-cell">
                  <span class="plate-text">{{ element.placa || '-' }}</span>
                  <span class="plate-meta" *ngIf="element.nome_empresa || element.nome_divisao">
                    {{ element.nome_empresa || element.nome_divisao }}
                  </span>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="gateway-row"
              [class.gateway-row-selected]="legacySelection.isSelected(row)"
              (click)="toggleRow(row, legacySelection)"></tr>
          </table>
          <p class="gateway-empty" *ngIf="legacyDataSource.filteredData?.length === 0">
            Nenhum terminal encontrado.
          </p>
        </div>
        <div class="gateway-section-actions">
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="openLegacy()"
            [disabled]="!legacySelection.selected.length">
            Abrir comandos (legado)
          </button>
        </div>
      </ng-container>
    </section>
  </div>
</div>

<div mat-dialog-actions align="end" class="gateway-dialog-actions">
  <button mat-button type="button" (click)="close()">Fechar</button>
</div>
